export const urlTypes = {
  NONE: 0,
  LOCAL: 1,
  EXTERNAL: 2
};
